import { render } from "./CadastroCupom.vue?vue&type=template&id=7b330a7a&scoped=true&lang=html"
import script from "./CadastroCupom.vue?vue&type=script&setup=true&lang=js"
export * from "./CadastroCupom.vue?vue&type=script&setup=true&lang=js"

import "./CadastroCupom.vue?vue&type=style&index=0&id=7b330a7a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b330a7a"]])

export default __exports__